export class BookingModuleGlobal {

    constructor(el) {
        this.el = el;
        this.method = this.el.querySelector("select#booking-option-method");
        this.params = Array.prototype.slice.call(this.el.querySelectorAll("[data-booking-param]"));
        this.results = this.el.querySelector("[data-booking-results]");
        this.spinner = this.el.querySelector("[data-booking-spinner]");
        this.submit = this.el.querySelector("[data-booking-submit]");

        this.isInitial = true;
        this.isLoading = false;
        this.state = {
            type: null
        };

        this.method.addEventListener("change", () => this.onMethodChange());
        this.submit.addEventListener("click", evt => this.onSubmitClicked(evt));

        this.onMethodChange();
        this.loadResults();
    }

    loadResults() {
        const params = {
            action: "booking_global",
            property: []
        };

        this.setLoading(true);

        this.params.forEach(param => {
            const isCheckbox = param.dataset.bookingParamCheckbox !== undefined;

            if (isCheckbox && param.parentNode.parentNode.classList.contains("d-none"))
                param.checked = false;

            if (param.name in params) {
                if (!(params[param.name] instanceof Array))
                    params[param.name] = [params[param.name]];

                if (!isCheckbox || (isCheckbox && param.checked))
                    params[param.name].push(param.value);
            } else if (!isCheckbox || (isCheckbox && param.checked)) {
                params[param.name] = param.value;
            }
        });

        this.results.style.setProperty("display", "none");
        this.results.innerHTML = "";

        if (this.isInitial)
            this.state = params;
        else
            history.pushState(params, "booking-request", `?from=${params.from}&to=${params.to}&persons=${params.persons}&type=${params.type}`);

        fetch(`/api/booking/${params.from}/${params.to}?persons=${params.persons}&type=${params.type}&props=${Object.values(params.property).join(",")}`)
            .then(r => r.json())
            .then(r => this.onResults(r))
            .catch(err => console.error(err));

        this.isInitial = false;
    }

    setLoading(isLoading = true) {
        this.isLoading = isLoading;

        if (isLoading)
            this.spinner.style.setProperty("display", "block");
        else
            this.spinner.style.setProperty("display", "none");
    }

    onMethodChange() {
        this.state.type = this.method.value;

        Array.prototype.slice.call(this.el.querySelectorAll(`[data-type="huurobject"]`)).forEach(el => el.style.setProperty("display", this.state.type === "house" ? "block" : "none"));
        Array.prototype.slice.call(this.el.querySelectorAll(`[data-type="kampeerplek"]`)).forEach(el => el.style.setProperty("display", this.state.type === "tent" ? "block" : "none"));

        if (this.state.type === "house") {
            Array.prototype.slice.call(this.el.querySelectorAll(`[data-booking-show-on="tent"]`)).forEach(el => el.classList.add("d-none"));
            Array.prototype.slice.call(this.el.querySelectorAll(`[data-booking-show-on="house"]`)).forEach(el => el.classList.remove("d-none"));
        } else {
            Array.prototype.slice.call(this.el.querySelectorAll(`[data-booking-show-on="house"]`)).forEach(el => el.classList.add("d-none"));
            Array.prototype.slice.call(this.el.querySelectorAll(`[data-booking-show-on="tent"]`)).forEach(el => el.classList.remove("d-none"));
        }
    }

    onResults(response) {
        if (!(response.data && response.success === true))
            return;

        for (let result of response.data) {
            let bestMatch = "";
            let otherPrices = "";

            if (result.prices && result.prices.length > 0) {
                let bm = result.prices.shift();
                let isSale = !(bm.price_before === null || bm.price_before === 0 || bm.price_before === bm.price);

                bestMatch += `<div class="booking-price"><div class="date-range"><span class="from">${bm.from_date_str}</span><span class="to">${bm.to_date_str}</span></div><div class="price"><a class="btn btn-primary" target="_blank" href="${bm.book_url}">${isSale ? `<span class="price-before">${bm.price_before_str}</span>` : ""}
											<span class="price${isSale ? "" : " price-alone"}">${bm.price_str}</span>
										</a>
									</div>
								</div>`;

                while (result.prices.length > 0) {
                    let p = result.prices.shift();

                    otherPrices += `<div class="booking-price"><div class="date-range"><span class="from">${p.from_date_str}</span><span class="to">${p.to_date_str}</span></div><div class="price"><span class="price">${p.price_str}</span></div><a class="btn btn-primary" target="_blank" href="${p.book_url}">${hcdcI18n.book_now}</a></div>`;
                }
            }

            const template = `<div class="box"><div class="overview-item accommodation-item"><header><a href="${result.accommodation.permalink}">${result.accommodation.name}</a><small>${result.camping.name}</small></header><a href="${result.accommodation.permalink}"><figure><div class="overview-photo" id="first" style="background-image: url(${result.accommodation.featured_image})"></div><div class="overview-photo" id="second" style="background-image: url(${result.accommodation.featured_image_hover})"></div></figure></a><main class="booking-prices best-match">${bestMatch}</main><main class="booking-prices other-results">${otherPrices}</main><footer><a class="btn btn-sm btn-secondary" href="${result.accommodation.permalink}">${hcdcI18n.moreOptions}</a></footer></div></div>`;

            this.results.innerHTML += template;
        }

        this.setLoading(false);
        this.results.style.setProperty("display", "flex");
    }

    onSubmitClicked(evt) {
        evt.preventDefault();

        this.loadResults();
    }

}
